import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CookieHelper } from '../../common/cookie-helper';
import { CountryLanguageHelper } from '../../common/country-language-helper';
import { DeviceTypeHelper } from '../../common/device-type-helper';
import { NgcSelectDirective } from '../../common/select.directive';
import { ApplicationConfig } from '../../config/config';
import { ContentCountryLanguage } from '../../model/content/contentCountryLanguage.model';
import { CommonService } from '../../services/common.service';
import { CountryLanguageService } from '../../services/country_Language/country_Language.service';

declare let delta: any;
declare let rhpr: any;

// import { AnimationBuilder, AnimationPlayer, style, animate } from '@angular/animations';

@Component({
  selector: 'ngc-langselector',
  templateUrl: 'flyout-langselector.component.html'
})
export class FlyoutLangselectorComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild('dialog') dialog: any;
  @ViewChild('languageDirective') languageDirective: NgcSelectDirective;
  @ViewChild('contryDirective') contryDirective: NgcSelectDirective;
  @ViewChild('searchField') searchField: any;
  countryLangForm: UntypedFormGroup;
  isSearchFocused: boolean;
  countryslector = 'us';
  langselector = 'en';
  primarylanguage = '';
  indexArray: any = [];
  listIndex: number;
  countryLanguageContent: ContentCountryLanguage;
  actionMethod = 'POST';
  actionUrl: string;
  displayButtonText: string;
  CLSTitle: string;
  CLSregion: string;
  CLSsearchplaceholder: string;
  CLSlocation: string;
  CLSsearchLabel: string;
  currentCLSLanguage: any;
  regionList;
  selectedRegionCountries = [];
  selectedRegion: any;
  deviceTypeSubscribe: Subscription;
  deviceTypes: any = [];
  countryLanguageList: any = [];
  languageList: any = [];
  prefCookieValue: any;
  searchValue: any;
  searchList: any = [];
  sortOptions: { name: string; descending: boolean } = {
    name: 'countryName',
    descending: false
  };

  sortOptionsLanguage: {
    name: string;
    descending: boolean;
    exceptionName: string;
    exceptionValue: string;
  } = {
    name: 'languageCode',
    descending: false,
    exceptionName: 'languageCode',
    exceptionValue: 'en'
  };

  // public player: AnimationPlayer;
  private animationTime = '300ms';
  private unsubscribe: Subject<void> = new Subject();
  private clsLanguageCodeToChange: string;
  private currentCountryCode: string;

  constructor(
    public bsModalRef: BsModalRef,
    private fb: UntypedFormBuilder,
    private cdf: ChangeDetectorRef,
    private srv: CommonService,
    private countryLangSvc: CountryLanguageService,
    private cookieHelper: CookieHelper,
    @Inject(PLATFORM_ID) private platformId: Object,
    private countryLanguageHelper: CountryLanguageHelper,
    private _deviceTypeHelper: DeviceTypeHelper,
    private appconfig: ApplicationConfig,
    private elementRef: ElementRef
  ) {
    this.prefCookieValue = this.cookieHelper.getCookies('prefUI');
  }

  ngOnInit() {
    if (this.appconfig.onBrowser) {
      this.deviceTypeSubscribe = this._deviceTypeHelper
        .deviceDetection()
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((resp) => {
          this.deviceTypes = resp;
        });
    }
    this.countryLangSvc
      .countryLanguageDataFromAPI()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data) => {
        this.countryLanguageHelper.setData(data);
        this.countryLanguageList =
          this.countryLanguageHelper.getCountryLanguageList();
        this.regionList = this.countryLanguageHelper.getRegionList();
        this.searchList = this.regionList;
        const countryCode =
          this.countryLanguageHelper.getCountryCodeFromPrefCookie();
        if (countryCode) {
          this.selectedRegion =
            this.countryLanguageHelper.getRegtionForCountryCode(countryCode);
        } else {
          this.selectedRegion =
            this.countryLanguageHelper.getRegtionForCountryCode('us');
        }
        if (this.selectedRegion) {
          for (let i = 0; i < this.searchList.length; i++) {
            if (this.selectedRegion === this.searchList[i]) {
              this.listIndex = i;
            }
          }
          this.onRegionClicked(this.selectedRegion, this.listIndex);
        }
        this.setClsValues(this.appconfig.get('APP_PREF_COOKIE'));
        this.countryLanguageHelper
          .getPreferedLangagues()
          .pipe(takeUntil(this.unsubscribe))
          .subscribe((dataVal) => {
            if (dataVal) {
              this.setClsValues(dataVal);
            }
          });
      });
    if (this.appconfig.onBrowser) {
      this.deviceTypeSubscribe = this._deviceTypeHelper
        .deviceDetection()
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((resp) => {
          this.deviceTypes = resp;
        });
    }
  }

  setClsValues(data: string) {
    data = data.toLowerCase();
    const res = data.split('-');
    this.currentCountryCode = res[1];
    this.currentCLSLanguage = res[0];
    if (res[0] === 'en') {
      this.displayButtonText = '';
    } else {
      this.displayButtonText =
        this.countryLanguageHelper.getTranslatedTextForLanguageCode(
          'en',
          'cls-display-button'
        );
      this.clsLanguageCodeToChange = 'en';
    }
    this.CLSTitle = this.countryLanguageHelper.getTranslatedTextForLanguageCode(
      res[0],
      'cls-title'
    );
    this.CLSregion =
      this.countryLanguageHelper.getTranslatedTextForLanguageCode(
        res[0],
        'cls-region'
      );
    this.CLSlocation =
      this.countryLanguageHelper.getTranslatedTextForLanguageCode(
        res[0],
        'cls-location'
      );
    this.CLSsearchplaceholder =
      this.countryLanguageHelper.getTranslatedTextForLanguageCode(
        res[0],
        'cls-search-placeholder'
      );
    this.CLSsearchLabel =
      this.countryLanguageHelper.getTranslatedTextForLanguageCode(
        res[0],
        'cls-search-label'
      );
    this.cdf.detectChanges();
  }

  focusToInput(event) {
    if (event.target.parentElement.previousElementSibling) {
      event.target.parentElement.previousElementSibling.focus();
    }
  }

  close() {
    // this.animateFooterSearchModalClose();
    this.setHTMLOverflow();
    this.bsModalRef.hide();
  }

  setHTMLOverflow() {
    document.getElementsByTagName('html')[0].style.overflow = '';
  }

  onRegionClicked(region: any, index?: number) {
    if (index !== null && index !== undefined) {
      const aelm: any = document.querySelectorAll('.region-container li a');
      for (let i = 0; i < aelm.length; i++) {
        this.indexArray[i] = false;
      }
      this.indexArray[index] = true;
    }
    this.selectedRegion = region;
    this.selectedRegionCountries = this.countryLanguageList.filter((item) => {
      return region.region_codes.indexOf(item.regionCode) !== -1;
    });
    this.cdf.detectChanges();
    if (
      isPlatformBrowser(this.platformId) &&
      document.getElementById('lacation-list-container')
    ) {
      document.getElementById('lacation-list-container').scrollTop = 0;
    }
  }

  onSearchFieldFocus() {
    this.isSearchFocused = true;
  }

  onSearchFieldFocusout() {
    this.isSearchFocused = false;
  }

  clearSearchField() {
    this.searchValue = '';
    this.searchField.nativeElement.focus();
  }

  customLangChangeEventHandler(val) {
    this.countryLangForm.controls['langselector'].setValue(val);
    this.langselector = val;
  }

  dispalyContentLanguage() {
    this.setClsValues(
      this.clsLanguageCodeToChange + '-' + this.currentCountryCode
    );
  }

  afterLanguageSelected(languageCode: string, countryCode: string) {
    if (isPlatformBrowser(this.platformId)) {
      let prefvalue = '';
      prefvalue = languageCode + '-' + countryCode;
      this.langselector = languageCode;
      this.countryslector = countryCode;
      this.cookieHelper.setCookies('prefUI', prefvalue);
      // this.countryLanguageHelper.setPreferedLanguages(prefvalue);
      this.setHTMLOverflow();
      this.bsModalRef.hide();
      document.getElementsByTagName('html')[0].classList.remove('no-scroll');
      if ('undefined' !== typeof rhpr && rhpr === true) {
        this.countryLanguageHelper.redirectToTranslatedSites(
          this.countryslector,
          this.langselector
        );
      } else {
        this.countryLanguageHelper.redirectToTranslatedSitesForContentPages(
          this.countryslector,
          this.langselector
        );
      }
    }
  }

  ngOnDestroy() {
    this.setHTMLOverflow();
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    if (this.deviceTypeSubscribe) {
      this.deviceTypeSubscribe.unsubscribe();
    }
    this.cdf.detach();
  }

  onSearchValueChanged(event) {
    let minLength = 2;
    this.searchValue = event.target.value;
    const match = this.searchValue.match(/^[a-zA-Z ]+$/);
    if (match) {
      minLength = 3;
    }
    if (
      this.searchValue &&
      this.searchValue !== '' &&
      this.searchValue.length >= minLength
    ) {
      this.searchList = [];
      const countryLang = Object.assign([], this.countryLanguageList);
      const searchList = countryLang.map((item, index) => {
        if (
          item.countryName
            .toLowerCase()
            .includes(this.searchValue.toLowerCase())
        ) {
          return item;
        } else {
          const langList = item.languageDtls.filter((lang) => {
            return (
              lang.languageName
                .toLowerCase()
                .includes(this.searchValue.toLowerCase()) ||
              lang.countryName
                .toLowerCase()
                .includes(this.searchValue.toLowerCase())
            );
          });
          if (langList.length > 0) {
            const new_item = Object.assign({}, item);
            new_item.languageDtls = langList;
            return new_item;
          }
          return null;
        }
      });
      if (searchList && searchList.length > 0) {
        this.searchList = searchList.filter((item) => {
          return item != null;
        });
      }
    } else {
      this.searchList = [];
    }
  }

  ngAfterViewInit() {
    const modalElement = document.getElementsByTagName('modal-container');
    if (modalElement && modalElement.length > 0) {
      modalElement[0].addEventListener(
        'click',
        this.backDropClickHandler.bind(this)
      );
    }
    this.srv.trapFocusInsideModal(this.elementRef);
  }

  backDropClickHandler(event) {
    const flyoutSearch = event.target.parentElement;
    if (flyoutSearch) {
      const isModalContainerClicked =
        event.target.classList.contains('search-header-modal') ||
        event.target.classList.contains('search-footer-modal') ||
        flyoutSearch.classList.contains('modal-content');
      if (isModalContainerClicked) {
        this.bsModalRef.hide();
        this.setHTMLOverflow();
        // this.animateFooterSearchModalClose();
      }
    }
  }

  // animateFooterSearchModalClose() {
  //   if (isPlatformBrowser(this.platformId)) {
  //     if (this.player) {
  //       this.player.destroy();
  //     }
  //     const factory = this._builder.build([
  //       style({ visibility: 'visible', opacity: 1 }),
  //       animate((this.animationTime + ' ease-out'), style({ opacity: 0 }))
  //     ]);
  //     this.player = factory.create(document.getElementsByClassName('lang-modal-content')[0], {});
  //     this.player.play();
  //     this.player.onDone(() => {
  //       this.bsModalRef.hide();
  //     });
  //   }
  // }

  scrollToView(regionView) {
    setTimeout(() => {
      regionView.scrollIntoView();
    }, 100);
  }

  getTranslatedRegionName(region: any) {
    const tranlsatedList = region['translated_regions'];
    if (tranlsatedList) {
      const tranlsatedRegion = tranlsatedList.filter((item) => {
        return item.languageCode.toLowerCase() === this.currentCLSLanguage;
      });
      if (tranlsatedRegion && tranlsatedRegion.length > 0) {
        return tranlsatedRegion[0].region_name;
      }
    }
    return region.region_name;
  }
}
